import { theme } from 'antd';
import { ThemeConfigType } from './typing';

const colorBgContainer = '#1a1a1a'; // Dark background
const colorBgLayout = '#000000'; // Darker layout background

const themeId = 'dark-high-contrast';

export const darkHighContrastTheme: ThemeConfigType = {
  id: themeId,
  type: 'dark',
  name: `themes.${themeId}`,
  previewImage: 'https://github.githubassets.com/assets/dark_high_contrast_preview-642fa816bf29.svg',
  previewImageDisc: 'https://github.githubassets.com/assets/dark_high_contrast_disc-3820ceab953a.svg',
  theme: {
    algorithm: [theme.darkAlgorithm],
    token: {
      blue: '#1E90FF', // Dodger Blue
      purple: '#800080', // Purple
      cyan: '#00FFFF', // Cyan
      green: '#00FF00', // Lime
      magenta: '#FF00FF', // Magenta
      pink: '#FF1493', // Deep Pink
      red: '#FF0000', // Red
      orange: '#FFA500', // Orange
      yellow: '#FFFF00', // Yellow
      volcano: '#FF4500', // Orange Red
      geekblue: '#4682B4', // Steel Blue
      gold: '#FFD700', // Gold
      lime: '#32CD32', // Lime Green
      colorPrimary: '#1E90FF', // Dodger Blue
      colorSuccess: '#32CD32', // Lime Green
      colorWarning: '#FFD700', // Gold
      colorError: '#FF4500', // Orange Red
      colorInfo: '#00FFFF', // Cyan
      colorLink: '#1E90FF', // Dodger Blue
      colorTextBase: '#FFFFFF', // White
      colorBgBase: '#000000', // Black
      lineWidth: 1,
      lineType: 'solid',
      borderRadius: 6,
      colorText: 'rgba(255, 255, 255, 0.85)', // High contrast text
      colorTextSecondary: 'rgba(255, 255, 255, 0.65)', // High contrast secondary text
      colorTextTertiary: 'rgba(255, 255, 255, 0.45)', // High contrast tertiary text
      colorTextQuaternary: 'rgba(255, 255, 255, 0.25)', // High contrast quaternary text
      colorFill: 'rgba(255, 255, 255, 0.15)', // High contrast fill
      colorFillSecondary: 'rgba(255, 255, 255, 0.1)', // High contrast secondary fill
      colorFillTertiary: 'rgba(255, 255, 255, 0.05)', // High contrast tertiary fill
      colorFillQuaternary: 'rgba(255, 255, 255, 0.02)', // High contrast quaternary fill
      colorBgLayout: colorBgLayout,
      colorBgContainer: colorBgContainer,
      colorBgElevated: '#2a2a2a', // Slightly lighter dark background
      colorBgSpotlight: 'rgba(255, 255, 255, 0.1)', // High contrast spotlight
      colorBgBlur: 'transparent',
      colorBorder: '#FFFFFF', // Dark border
      colorBorderSecondary: '#FFFFFF', // Slightly lighter dark border
      // colorPrimaryBg: '#1a1a1a', // Dark primary background
      // colorPrimaryBgHover: '#000000', // Darker primary background hover
      // colorPrimaryBorder: '#1E90FF', // Primary border
      // colorPrimaryBorderHover: '#1C86EE', // Darker primary border hover
      // colorPrimaryHover: '#1C86EE', // Darker primary hover
      // colorPrimaryActive: '#1874CD', // Even darker primary active
      // colorPrimaryTextHover: '#1E90FF', // Primary text hover
      // colorPrimaryText: '#1E90FF', // Primary text
      // colorPrimaryTextActive: '#1874CD', // Primary text active
      colorSuccessBg: '#1a1a1a', // Dark success background
      colorSuccessBgHover: '#000000', // Darker success background hover
      colorSuccessBorder: '#32CD32', // Success border
      colorSuccessBorderHover: '#2EB82E', // Darker success border hover
      colorSuccessHover: '#2EB82E', // Darker success hover
      colorSuccessActive: '#28A428', // Even darker success active
      colorSuccessTextHover: '#32CD32', // Success text hover
      colorSuccessText: '#32CD32', // Success text
      colorSuccessTextActive: '#28A428', // Success text active
      colorErrorBg: '#1a1a1a', // Dark error background
      colorErrorBgHover: '#000000', // Darker error background hover
      colorErrorBgActive: '#000000', // Darker error background active
      colorErrorBorder: '#FF4500', // Error border
      colorErrorBorderHover: '#E03C00', // Darker error border hover
      colorErrorHover: '#E03C00', // Darker error hover
      colorErrorActive: '#C03600', // Even darker error active
      colorErrorTextHover: '#FF4500', // Error text hover
      colorErrorText: '#FF4500', // Error text
      colorErrorTextActive: '#C03600', // Error text active
      colorWarningBg: '#1a1a1a', // Dark warning background
      colorWarningBgHover: '#000000', // Darker warning background hover
      colorWarningBorder: '#FFD700', // Warning border
      colorWarningBorderHover: '#E5C700', // Darker warning border hover
      colorWarningHover: '#E5C700', // Darker warning hover
      colorWarningActive: '#CCB700', // Even darker warning active
      colorWarningTextHover: '#FFD700', // Warning text hover
      colorWarningText: '#FFD700', // Warning text
      colorWarningTextActive: '#CCB700', // Warning text active
      colorInfoBg: '#1a1a1a', // Dark info background
      colorInfoBgHover: '#000000', // Darker info background hover
      colorInfoBorder: '#00FFFF', // Info border
      colorInfoBorderHover: '#00E5E5', // Darker info border hover
      colorInfoHover: '#00E5E5', // Darker info hover
      colorInfoActive: '#00CCCC', // Even darker info active
      colorInfoTextHover: '#00FFFF', // Info text hover
      colorInfoText: '#00FFFF', // Info text
      colorInfoTextActive: '#00CCCC', // Info text active
      colorLinkHover: '#1C86EE', // Darker link hover
      colorLinkActive: '#1874CD', // Even darker link active
      colorBgMask: 'rgba(0, 0, 0, 0.5)', // Dark mask
      colorWhite: '#FFFFFF', // White
      lineWidthBold: 2,
      colorFillContent: 'rgba(255, 255, 255, 0.15)', // High contrast fill content
      colorFillContentHover: 'rgba(255, 255, 255, 0.25)', // High contrast fill content hover
      colorFillAlter: 'rgba(255, 255, 255, 0.05)', // High contrast fill alter
      colorBgContainerDisabled: 'rgba(255, 255, 255, 0.05)', // High contrast container disabled
      colorBorderBg: '#3a3a3a', // Dark border background
      colorSplit: 'rgba(255, 255, 255, 255)', // High contrast split
      colorTextPlaceholder: 'rgba(255, 255, 255, 0.3)', // High contrast text placeholder
      colorTextDisabled: 'rgba(255, 255, 255, 0.2)', // High contrast text disabled
      colorTextHeading: 'rgba(255, 255, 255, 0.85)', // High contrast text heading
      colorTextLabel: 'rgba(255, 255, 255, 0.65)', // High contrast text label
      colorTextDescription: 'rgba(255, 255, 255, 0.45)', // High contrast text description
      colorTextLightSolid: '#FFFFFF', // White text
      colorHighlight: '#FFD700', // Gold highlight
      colorBgTextHover: 'rgba(255, 255, 255, 0.05)', // High contrast background text hover
      colorBgTextActive: 'rgba(255, 255, 255, 0.1)', // High contrast background text active
      colorIcon: 'rgba(255, 255, 255, 0.85)', // High contrast icon
      colorIconHover: 'rgba(255, 255, 255, 1)', // High contrast icon hover
      colorErrorOutline: 'rgba(255, 69, 0, 0.8)', // High contrast error outline
      colorWarningOutline: 'rgba(255, 215, 0, 0.8)', // High contrast warning outline
      controlItemBgHover: 'rgba(255, 255, 255, 0.1)', // High contrast control item background hover
      controlItemBgActive: '#000000', // Dark control item background active
      controlItemBgActiveHover: '#1a1a1a', // Dark control item background active hover
      controlItemBgActiveDisabled: 'rgba(255, 255, 255, 0.05)', // High contrast control item background active disabled
      controlTmpOutline: 'rgba(255, 255, 255, 0.3)', // High contrast control temporary outline
      controlOutline: 'rgba(255, 255, 255, 0.15)', // High contrast control outline
      linkDecoration: 'none',
      linkHoverDecoration: 'underline',
      linkFocusDecoration: 'underline',
      boxShadow:
        '\n      0 6px 16px 0 rgba(0, 0, 0, 0.8),\n      0 3px 6px -4px rgba(0, 0, 0, 0.6),\n      0 9px 28px 8px rgba(0, 0, 0, 0.4)\n    ',
      boxShadowSecondary:
        '\n      0 6px 16px 0 rgba(0, 0, 0, 0.8),\n      0 3px 6px -4px rgba(0, 0, 0, 0.6),\n      0 9px 28px 8px rgba(0, 0, 0, 0.4)\n    ',
      boxShadowTertiary:
        '\n      0 1px 2px 0 rgba(0, 0, 0, 0.6),\n      0 1px 6px -1px rgba(0, 0, 0, 0.4),\n      0 2px 4px 0 rgba(0, 0, 0, 0.2)\n    ',
    },
  },
  layout: {
    hashId: themeId,
    colorPrimary: '#1E90FF', // Dodger Blue
    colorTextAppListIcon: 'rgba(255, 255, 255, 0.85)', // High contrast app list icon text
    colorBgAppListIconHover: 'rgba(255, 255, 255, 0.1)', // High contrast app list icon background hover
    colorTextAppListIconHover: 'rgba(255, 255, 255, 1)', // High contrast app list icon text hover
    bgLayout: `linear-gradient(${colorBgContainer}, ${colorBgLayout} 28%)`,
    sider: {
      paddingInlineLayoutMenu: 8,
      paddingBlockLayoutMenu: 0,
      colorBgCollapsedButton: '#1a1a1a', // Dark collapsed button background
      colorTextCollapsedButtonHover: 'rgba(255, 255, 255, 1)', // High contrast collapsed button text hover
      colorTextCollapsedButton: 'rgba(255, 255, 255, 0.85)', // High contrast collapsed button text
      colorMenuBackground: 'transparent',
      colorMenuItemDivider: 'rgba(255, 255, 255, 255)', // High contrast menu item divider
      colorBgMenuItemHover: 'rgba(255, 255, 255, 0.2)', // High contrast menu item background hover
      colorBgMenuItemSelected: 'rgba(255, 255, 255, 0.3)', // High contrast menu item background selected
      colorTextMenuItemHover: 'rgba(255, 255, 255, 1)', // High contrast menu item text hover
      colorTextMenuSelected: 'rgba(255, 255, 255, 1)', // High contrast menu item text selected
      colorTextMenuActive: 'rgba(255, 255, 255, 1)', // High contrast menu item text active
      colorTextMenu: 'rgba(255, 255, 255, 0.85)', // High contrast menu item text
      colorTextMenuSecondary: 'rgba(255, 255, 255, 0.65)', // High contrast menu item secondary text
      colorTextMenuTitle: 'rgba(255, 255, 255, 0.85)', // High contrast menu item title text
      colorTextSubMenuSelected: 'rgba(255, 255, 255, 1)', // High contrast sub-menu item text selected
      colorBgMenuItemActive: 'rgba(255, 255, 255, 0.05)', // High contrast menu item background active
      colorBgMenuItemCollapsedElevated: 'transparent'
    },
    header: {
      colorBgHeader: 'rgba(0, 0, 0, 0.8)', // Dark header background
      colorBgScrollHeader: 'rgba(0, 0, 0, 0.9)', // Dark scroll header background
      colorHeaderTitle: 'rgba(255, 255, 255, 0.85)', // High contrast header title text
      colorBgMenuItemHover: 'rgba(255, 255, 255, 0.2)', // High contrast menu item background hover
      colorBgMenuItemSelected: 'transparent',
      colorTextMenuSelected: 'rgba(255, 255, 255, 1)', // High contrast menu item text selected
      colorBgRightActionsItemHover: 'rgba(255, 255, 255, 0.2)', // High contrast right actions item background hover
      colorTextRightActionsItem: 'rgba(255, 255, 255, 0.85)', // High contrast right actions item text
      heightLayoutHeader: 56,
      colorTextMenu: 'rgba(255, 255, 255, 0.85)', // High contrast menu text
      colorTextMenuSecondary: 'rgba(255, 255, 255, 0.65)', // High contrast secondary menu text
      colorTextMenuActive: 'rgba(255, 255, 255, 1)', // High contrast active menu text
      colorBgMenuElevated: 'rgba(0, 0, 0, 0.8)', // Dark elevated menu background
    },
    pageContainer: {
      colorBgPageContainer: 'transparent',
      paddingInlinePageContainerContent: 40,
      paddingBlockPageContainerContent: 32,
      colorBgPageContainerFixed: '#1a1a1a', // Dark fixed page container background
    },
  },
};
